import { motion } from "framer-motion";
import { scrollToSection } from "@/lib/scroll";

const links = [
  { label: "Products", target: "#products", testid: "nav-products-link" },
  { label: "Scrap", target: "#scrap", testid: "nav-scrap-link" },
  { label: "Contact", target: "#contact", testid: "nav-contact-link" },
];

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-[#262626] bg-black/80 backdrop-blur-md"
      data-testid="main-nav"
    >
      <div className="flex items-center justify-between px-6 md:px-12 h-16">
        <button
          onClick={() => scrollToSection("#top")}
          className="flex items-center gap-3 group"
          data-testid="nav-logo-button"
        >
          <img
            src="/logo-monogram.png"
            alt="Ameer Iron & Steels monogram"
            className="h-9 w-auto blend-screen transition-transform duration-500 group-hover:scale-110"
          />
          <span className="font-display text-sm tracking-[0.25em] uppercase text-steel-soft hidden sm:block">
            Ameer Iron &amp; Steels
          </span>
        </button>

        <nav className="flex items-center gap-6 md:gap-10">
          {links.map((l) => (
            <button
              key={l.label}
              onClick={() => scrollToSection(l.target)}
              className="text-xs uppercase tracking-[0.2em] text-[#a3a3a3] hover:text-[#f5f5f5] transition-colors duration-300"
              data-testid={l.testid}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollToSection("#quote")}
            className="text-xs uppercase tracking-[0.2em] bg-[#f5f5f5] text-[#050505] px-4 py-2 hover:bg-[#d4d4d4] transition-colors duration-300"
            data-testid="nav-quote-button"
          >
            Get a Quote
          </button>
        </nav>
      </div>
    </motion.header>
  );
}
